import { jsx as m } from "react/jsx-runtime";
import f from "classnames";
import s from "../../utils/colors.js";
import { a as p } from "../../styled-qu50FBLM.mjs";
import { Svg as c, Path as h } from "./Elements.js";
const x = ({
  className: r = "",
  fill: t = s.blueGrey,
  viewBox: l = "0 0 67 65",
  d: a = "M64.12 17.44A10.34 10.34 0 0 0 67 10.26 10.16 10.16 0 0 0 57 0a9.9 9.9 0 0 0-7 2.94zm-61.24 0A10.34 10.34 0 0 1 0 10.26 10.16 10.16 0 0 1 10 0a9.9 9.9 0 0 1 7 2.94zm30.62-14C16.88 3.42 3.35 17.23 3.35 34.21S16.88 65 33.5 65s30.15-13.81 30.15-30.79S50.12 3.42 33.5 3.42zm7.68 43.47l-10-10.26a3.45 3.45 0 0 1-1-2.42V17.1h6.7v15.69l9.07 9.26z",
  $transition: e = "fill 0.1s ease-in-out",
  $cssHelper: i = p,
  focusable: o
}) => /* @__PURE__ */ m(
  c,
  {
    viewBox: l,
    className: f({ [r]: !!r }),
    $cssHelper: i,
    focusable: !!o,
    "aria-hidden": !o,
    children: /* @__PURE__ */ m(h, { fill: t, d: a, $transition: e })
  }
);
export {
  x as default
};
